
import Layout from './Amministration/Layout';

function App() {
  return (
    <>
    <Layout></Layout >
    </>
    
  );
}

export default App;
